import { LorebookVisibility } from "@next-platform/packages-ts-types";

import { NSFW_TAGS } from "@/constants";

interface ICreateLorebookDiscoverFiltersParameters {
  applicationId?: string;
  favoriteIds?: string[] | null;
  isFavoritesMode: boolean;
  shouldFilterNsfwLorebooks: boolean;
}

const createLorebookDiscoverFilters = ({
  applicationId,
  favoriteIds,
  isFavoritesMode,
  shouldFilterNsfwLorebooks,
}: ICreateLorebookDiscoverFiltersParameters): string => {
  const clauses = [`visibility:${LorebookVisibility.PUBLIC}`];

  if (applicationId) {
    clauses.push(`application_ids:${applicationId}`);
  }
  if (shouldFilterNsfwLorebooks) {
    clauses.push(`tags:![${NSFW_TAGS.join(",")}]`);
    clauses.push("is_nsfw:false");
  }
  if (isFavoritesMode) {
    clauses.push(favoriteIds?.length ? `lorebook_id:[${favoriteIds.map((id) => `'${id}'`).join(",")}]` : "lorebook_id:null");
  }

  return clauses.join(" && ");
};

export default createLorebookDiscoverFilters;
